module.exports = __webpack_public_path__ + "static/media/2.ad032ef1.jpg";